import script from "./ProdutosAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProdutosAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./ProdutosAdministrar.vue?vue&type=style&index=0&id=7532ccf4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7532ccf4"]])

export default __exports__